import { getScanDateList, getCommon } from '@/components/report/service';
import { CALCWEIGHT, Aggregator } from '@/models/GenerateCondit/Interrelated';
import moment from 'moment';
import { getToDay } from '@/utils/date';
import { message } from 'antd';
import {
  getAccess,
  GetProvinceAreaAuth,
  getProvinceId,
  InitOrganizationAuth,
} from '@/services/area';
import { crudRequest } from '@/services/api';

let [startDate] = getToDay();
export default {
  namespace: 'lineloadingratedetail',
  state: {
    searchParams: {
      startDate: startDate.subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss'),
      endDate: undefined,
      departureCenter: undefined,
      arrivalCenter: undefined,
      departureProvinceArea: undefined,
      arrivalProvinceArea: undefined,
      lineName: undefined,
      lineSelect: 'shiftName',
      transportLineType: ['长线', '短线', '支线'],
      filling: undefined,
      taskNo: undefined,
      taskAttribute: '',
      transportStatus: '',
      zhuangzailv: 'isEwbNo1',
    },

    onSearch: false,
    tableDatas: [],
    calcWeightCount: 0, // 结算重量之和
    volumeCount: 0, // 体积之和
    actualCapacityCount: 0, // 实际运力之和
    actualPositionCount: 0, // 实际仓位之和
    access: {
      isHead: false,
      isArea: false,
      isCenter: true,
      code: '',
    },
  },

  effects: {
    /**
     * 获取数据
     */
    *getData({ payload }, { call, put, select }) {
      // const {
      //   departureCenter,
      //   arrivalCenter,
      //   transportLineType,
      //   filling,
      //   weekType,
      //   startDate,
      //   endDate,
      //   lineName,
      //   taskNo,
      // } = payload;

      crudRequest('/api/route/lineLoadingRateDetail/search');
      let lineloadingratedetail = yield select(
        ({ lineloadingratedetail }) => lineloadingratedetail,
      );

      const { tableDatas, limit, offset, searchParams, access } = lineloadingratedetail;
      const {
        departureCenter,
        arrivalCenter,
        departureProvinceArea,
        arrivalProvinceArea,
        transportLineType,
        filling,
        startDate,
        endDate,
        lineName,
        lineSelect,
        taskNo,
        taskAttribute,
        transportStatus,
        min, // 结算装载率范围
        max, // 结算装载率范围
      } = searchParams;

      if (!access.isHead && departureCenter == null) {
        message.warn('请选择出发组织');
        return;
      }

      let inFilters = [];

      if (transportLineType && searchParams?.transportLineType.length !== 3) {
        inFilters.push({ key: 'transportLineType', value: transportLineType });
      }

      let andFilters = [];
      if (departureCenter && departureCenter.length > 0) {
        if (departureCenter.length == 2) {
          andFilters.push({ key: 'departureCenter', value: departureCenter.lastItem });
        } else {
          andFilters.push({
            key: 'departureProvinceArea',
            value: departureCenter.lastItem,
          });
        }
      }
      if (arrivalCenter && arrivalCenter.length > 0) {
        if (arrivalCenter.length == 2) {
          andFilters.push({ key: 'arrivalCenter', value: arrivalCenter.lastItem });
        } else {
          andFilters.push({ key: 'arrivalProvinceArea', value: arrivalCenter.lastItem });
          // andFilters.push({ key: 'arrivalProvinceArea', value: '云南省区' });
        }
      }
      if (taskAttribute) {
        andFilters.push({ key: 'taskAttribute', value: taskAttribute });
      }
      if (transportStatus) {
        andFilters.push({ key: 'transportStatus', value: transportStatus });
      }

      if (taskNo) {
        andFilters.push({ key: 'taskNo', value: taskNo });
      }

      let notFilters = [];
      if (filling) {
        notFilters.push({ key: 'filling', value: filling });
      }

      let likeFilters = [];
      if (lineName) {
        likeFilters.push({ key: lineSelect, value: `^*${lineName}` });
      }

      // const filter = {
      //   // title: '中转发出-实际',
      //   dataSource: 't_load_rate_goods_result',
      //   dimensions: dimensions,
      //   simpleGranularity: 'day',
      //   startDate: startDate.format('YYYY-MM-DD HH:mm:ss'),
      //   endDate: endDate.format('YYYY-MM-DD HH:mm:ss'),
      //   andFilters: andFilters,
      //   inFilters: [],
      //   notFilters,
      //   aggregators: [CALCWEIGHT, new Aggregator('doubleSum', 'volume', 'volume')],
      // };

      let dimensions2 = [
        'direction', // 流向
        'taskNo', // 任务号
        'departureProvinceArea',
        'arrivalProvinceArea',
        'shiftName', // 计划线路名称
        'lineName', // 实际线路名称
        // 'actualCapacity', // 实际运力
        // 'actualPosition', // 实际仓位
        'carType', // 车型(13.7、9.6、17)
        'carMode', // 装卸模式(两地装、两地卸)
        'carNo', // 车牌号
        'transportStatus', // 运输状态(已完成、一调度)
        'departureCenter', // 流向出发分拨
        'arrivalCenter', // 流向到达分拨
        'transportLineType', // 线路类型
        'taskAttribute', // 班次性质
        '__time', // 日期
        'totalCalcWeightRate', // 结算装载率
        'totalVolumeRate', // 体积装载率
        'totalErrorType', // 空仓爆仓
      ];
      const requestObj = {
        dataSource: 't_load_rate_comp_result',
        startDate: startDate,
        endDate: endDate,
        simpleGranularity: 'day',
        dimensions: dimensions2,
        andFilters: andFilters,
        notFilters,
        likeFilters,
        inFilters,
        // limit,
        // offset,
        aggregators: [
          new Aggregator('doubleSum', 'actualCapacity', 'actualCapacity'),
          new Aggregator('doubleSum', 'totalCalcWeight', 'totalCalcWeight'),
          new Aggregator('doubleSum', 'totalVolume', 'totalVolume'),
          new Aggregator('doubleSum', 'actualPosition', 'actualPosition'),
        ],
      };
      if (min || max) {
        requestObj['boundFilters'] = [
          {
            dimension: 'totalCalcWeightRate',
            lowerEq: false,
            lowerValue: min,
            upperEq: false,
            upperValue: max,
          },
        ];
      }
      const volumeResult = yield call(getCommon, requestObj);

      if (!volumeResult) {
        // message.error('查询出现错误');
        return;
      }

      ///////////////////--------------------

      // let taskNoArr = JSON.parse(volumeResult.data || null).map(item => item.event.taskNo);
      // console.log('volumeResult: ', JSON.parse(volumeResult.data || null));

      // let dimensions = [
      //   // 'direction', // 流向
      //   'taskNo', // 任务号
      //   // 'calcWeight', // 结算重量
      //   // 'operateWeight', // 运营重量
      //   // 'directionDepartureCenter', // 流向出发分拨
      //   // 'directionArrivalCenter', // 流向到达分拨
      //   // 'volume', // 体积
      //   // '__time', // 日期
      // ];
      // const result = yield call(getCommon, {
      //   dataSource: 't_load_rate_goods_result',
      //   dimensions: dimensions,
      //   simpleGranularity: 'day',
      //   startDate: startDate,
      //   endDate: endDate,
      //   aggregators: [CALCWEIGHT, new Aggregator('doubleSum', 'volume', 'volume')],
      //   andFilters: [],
      //   notFilters,
      //   inFilters: [{ key: 'taskNo', value: taskNoArr }],
      // });
      // if (!result) {
      //   return;
      // }

      /**
       * actualCapacity  车额定运力
       * actualPosition  车额定体积
       * totalCalcWeight 车装载重量
       * totalVolume 车装载体积
       * totalCalcWeightRate 结算装载率
       * totalVolumeRate 体积装载率
       */

      let calcWeightCount = 0; // 结算重量之和
      let volumeCount = 0; // 体积之和
      let actualCapacityCount = 0; // 实际运力之和
      let actualPositionCount = 0; // 实际仓位之和

      // console.log('result.data: ', JSON.parse(result.data));

      // const goodsData = JSON.parse(result.data || null)
      //   .map(item => item.event)
      //   .map(item => {
      //     return {
      //       ...item,
      //       calcWeight: item.calcWeight ? Math.abs(item.calcWeight) : item.calcWeight,
      //       volume: item.volume ? Math.abs(item.volume) : item.volume,
      //     };
      //   })
      //   .reduce((pre, current) => {
      //     pre[current.taskNo] = current;
      //     calcWeightCount += current.calcWeight;
      //     volumeCount += current.volume;
      //     return pre;
      //   }, {});

      // let calcWeightCount2 = 0; // 结算重量之和
      // let volumeCount2 = 0; // 体积之和

      const volumeData = JSON.parse(volumeResult.data || null)
        .map(item => item.event)
        .map(item => {
          return {
            ...item,
            calcWeight: item.totalCalcWeight
              ? Math.abs(item.totalCalcWeight)
              : item.totalCalcWeight,
            volume: item.totalVolume ? Math.abs(item.totalVolume) : item.totalVolume,
          };
        })
        .reduce((pre, current) => {
          pre[current.taskNo] = current;
          actualCapacityCount += current.actualCapacity;
          actualPositionCount += current.actualPosition;
          calcWeightCount += current.calcWeight;
          volumeCount += current.volume;
          return pre;
        }, {});

      yield put({
        type: 'updateState',
        payload: {
          calcWeightCount, // 结算重量之和
          volumeCount, // 体积之和
          actualCapacityCount, // 实际运力之和
          actualPositionCount, // 实际仓位之和
        },
      });

      let newTableDatas = [];
      // let countData = {}
      Object.entries(volumeData).forEach(([key, value]) => {
        // console.log('value: ', value);

        // let goodItem = goodsData[value.taskNo];
        // volumeData[
        //   `${value.taskNo}-${value.directionDepartureCenter}-${value.directionArrivalCenter}`
        // ];

        // if (!volumeItem) {
        //   return;
        // }
        const settlementLoadingRate = value.totalCalcWeightRate;

        let volumeLoadingRate = value.totalVolumeRate;
        // let settlementLoadingRate = goodItem?.calcWeight / value?.actualCapacity / 1000; // 结算装载率
        // let volumeLoadingRate = goodItem?.volume / value?.actualPosition; // 体积装载率
        // let exceptionType =
        //   settlementLoadingRate > 80 ? (settlementLoadingRate > 90 ? '爆仓' : '') : '空仓'; //判断结算装载率 小于80%空仓   大于90% 爆仓

        let __time = moment(value.druidDefaultSearchTime).format('MM/DD');
        // 增加范围筛选
        const obj = {
          ...value,
          // ...(goodItem ?? {}),
          calcWeight: value.totalCalcWeight && Math.abs(value.totalCalcWeight / 1),
          settlementLoadingRate,
          volumeLoadingRate,
          exceptionType: value.totalErrorType ? value.totalErrorType : '',
          __time,
        };

        // const rate = settlementLoadingRate / 1;
        // if (min && max) {
        //   if (rate >= min && rate <= max) {
        //     newTableDatas.push(obj);
        //   }
        // } else if (min) {
        //   if (rate >= min) {
        //     newTableDatas.push(obj);
        //   }
        // } else if (max) {
        //   if (rate <= max) {
        //     newTableDatas.push(obj);
        //   }
        // } else {
        newTableDatas.push(obj);
        // }
      });

      // 处理加载数据
      let newResult;
      if (offset === 0) {
        newResult = newTableDatas;
      } else {
        newResult = [...tableDatas, ...newTableDatas];
      }
      yield put({
        type: 'updateState',
        payload: {
          tableDatas: newResult,
          limit,
          offset,
        },
      });
    },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    updateSearchParams(state, { payload }) {
      return { ...state, searchParams: { ...state.searchParams, ...payload } };
    },

    resetState(state) {
      return { state, tableDatas: [], offset: undefined };
    },
  },
};
